import {KontaktState} from '../states/kontakt.state';
import {createReducer, on} from '@ngrx/store';
import {KontaktActions} from '../actions/kontakt.actions';
import {FakturierungsbelegFormActions} from '../actions/fakturierungsbeleg-form.actions';


export const initialKontaktState: KontaktState = {
  displayedIds: [],
  filterDto: {},
  pageableDto: {
    size: 15,
    number: 0,
  },
  readMoreKunden: false,
};

export const kontaktReducer = createReducer(
  initialKontaktState,

  on(
    KontaktActions.setDisplayedIds,
    (state, {kundeDtos}) => ({
      ...state,
      displayedIds: kundeDtos.map(kundeDto => kundeDto.id!),
    }),
  ),

  on(
    KontaktActions.addDisplayedIds,
    (state, {kundeDtos}) => ({
      ...state,
      displayedIds: [
        ...state.displayedIds,
        ...kundeDtos.map(kundeDto => kundeDto.id!),
      ],
    }),
  ),

  on(KontaktActions.clearDisplayedKunden,
    (state) => ({
      ...state,
      displayedIds: [],
    }),
  ),

  on(KontaktActions.addDisplayedId, (state, {kundeId}) => {
    let updatedDisplayedIds = [...state.displayedIds];
    if (!updatedDisplayedIds.includes(kundeId!)) {
      updatedDisplayedIds = [
        ...updatedDisplayedIds,
        kundeId!,
      ];
    }

    return {
      ...state,
      displayedIds: updatedDisplayedIds,
    };
  }),

  on(FakturierungsbelegFormActions.changeKontaktMode, (state, {mode}) => {
    if (mode === 'display') {
      return {
        ...state,
        readMoreKunden: false,
        filterDto: {
          ...initialKontaktState.filterDto,
        },
        pageableDto: {
          ...initialKontaktState.pageableDto,
        },
      };
    }

    return {
      ...state,
    };
  }),

  on(KontaktActions.triggerReadMoreKunden, (state) => {
    return {
      ...state,
      readMoreKunden: true,
      pageableDto: {
        ...state.pageableDto,
        number: (state.pageableDto.number || 0) + 1,
      },
    };
  }),


  on(KontaktActions.updateTextFilter, (state, {textFilter}) => {
    return {
      ...state,
      readMoreKunden: false,
      filterDto: {
        name: textFilter,
      },
      pageableDto: {
        ...initialKontaktState.pageableDto,
      }
    };
  })
);
